import {
  extent,
  type ScaleLinear,
  type ScaleTime,
  scaleLinear,
  scaleTime,
} from "d3";

interface Params {
  width: number;
  height: number;
  dates: Date[];
  values: number[];
}

/**
 * @example
 * const [xScale, yScale] = miniGameChartsScales({
 *    width: 100,
 *    height: 100,
 *    dates: [new Date(0), new Date(1), new Date(2)],
 *    values: [1, 2, 3],
 *  });
 */
export function miniGameChartsScales(
  params: Params,
): [ScaleTime<number, number>, ScaleLinear<number, number>] {
  const { width, height, dates, values } = params;

  const xScale = scaleTime()
    .domain(extent(dates) as [Date, Date])
    .range([0, width]);

  const yScale = scaleLinear()
    .domain(extent(values) as [number, number])
    .range([height, 0])
    .nice();

  return [xScale, yScale];
}
